import {
    SOCKET_CONNECT_SEND,
    SOCKET_CONNECT_SUCCESS,
    SOCKET_CONNECT_FAIL
} from '../constants/action-types';

const SEND = SOCKET_CONNECT_SEND;
const SEND_SUCCESS = SOCKET_CONNECT_SUCCESS;
const SEND_FAIL = SOCKET_CONNECT_FAIL;

export function socketConnect() {
    return {
        type: 'socket',
        types: [SEND, SEND_SUCCESS, SEND_FAIL],
        promise: socket => socket.connect()
    };
}

export function socketRegisterUser(user_id) {
    return {
        type: 'socket',
        types: [SEND, SEND_SUCCESS, SEND_FAIL],
        promise: socket => socket.registerUser(user_id)
    };
}

export function socketUnregisterUser() {
    return {
        type: 'socket',
        types: [SEND, SEND_SUCCESS, SEND_FAIL],
        promise: socket => socket.unregisterUser()
    };
}



// WEBPACK FOOTER //
// ./source/actions/socketActions.js